import { render, staticRenderFns } from "./CapjCifras.vue?vue&type=template&id=12200dcc&"
import script from "./CapjCifras.vue?vue&type=script&lang=js&"
export * from "./CapjCifras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports